<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { enforce_resolution_label } = currentAccount.value?.settings || {};
    isEnabled.value = !!enforce_resolution_label;
  },
  { deep: true, immediate: true }
);

const toggleEnforcement = async () => {
  try {
    await updateAccount({ enforce_resolution_label: isEnabled.value });
    useAlert(t('GENERAL_SETTINGS.FORM.ENFORCE_RESOLUTION_LABEL.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.ENFORCE_RESOLUTION_LABEL.API.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.ENFORCE_RESOLUTION_LABEL.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ENFORCE_RESOLUTION_LABEL.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleEnforcement" />
      </div>
    </template>
  </SectionLayout>
</template>
